import * as React from "react";
import { cn } from "@/lib/utils";

interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: React.ReactNode;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, label, id, ...props }, ref) => {
    return (
      <label className="relative inline-flex items-center cursor-pointer gap-2">
        <input
          type="checkbox"
          ref={ref}
          id={id}
          className="sr-only peer"
          {...props}
        />
        <div
          className={cn(
            "w-9 h-5 bg-muted rounded-full peer peer-checked:bg-primary peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all",
            className
          )}
        />
        {label && (
          <span className="text-sm text-muted-foreground">{label}</span>
        )}
      </label>
    );
  }
);
Switch.displayName = "Switch";
